import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService } from 'app/services/data.service';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-update-ar-limit-dialog',
  templateUrl: './update-ar-limit-dialog.component.html',
  styleUrls: ['./update-ar-limit-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class UpdateARLimitDialogComponent implements OnInit {
  data: any = {};
  isValid: boolean = false;
  confirmationText: string = '';
  amount = null;
  change: any;
  validate: any = {};
  focus: any = { newLimit: true };
  timeoutId: any;
  usd: string = currency.USD;
  isCurrentUnlimted: boolean = false;
  limitErrorMsg = '';
  constructor(private dialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef, private dataService: DataService) {}

  ngOnInit() {
    this.data = this.dialogConfig.data;
    this.isCurrentUnlimted = this.data?.isCurrentUnlimted;
  }

  handleChange(value: string) {
    this.focus.newLimit = true;
    this.limitErrorMsg = '';
    this.amount = value;
    
  }

  handleFocus() {
    this.focus.newLimit = true;
    // if (isNaN(this.amount)) {
      this.amount = 0;
    // }
  }


  closeDialog(isSuccess: boolean, btn = '') {
    // if(!this.data.unlimited && (this.amount < this.data?.availableLimit)) {
    //   this.limitErrorMsg = 'New limit cannot be less then available limit';
    //   return;
    // }
    this.dynamicDialogRef.close({ isSuccess, data: this.amount });
  }
}
